import React, { useState } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { LayoutDashboard, PieChart, FileText, User, Moon, Sun, Menu, X } from 'lucide-react';
import UserMenu from './UserMenu';

const THEME_KEY = 'rgnr_client_theme';

const NAV = [
  { to: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/portfolio', label: 'Portfolio', icon: PieChart },
  { to: '/letters', label: 'Letters', icon: FileText },
  { to: '/profile', label: 'Profile', icon: User },
];

function ClientLayout() {
  const [theme, setTheme] = useState(() => localStorage.getItem(THEME_KEY) || 'light');
  const [mobileOpen, setMobileOpen] = useState(false);

  const toggleTheme = () => {
    setTheme((prev) => {
      const next = prev === 'dark' ? 'light' : 'dark';
      localStorage.setItem(THEME_KEY, next);
      return next;
    });
  };

  return (
    <div className="client-shell" data-theme={theme}>
      <header className="client-topnav">
        <div className="client-topnav-inner">
          <NavLink to="/dashboard" className="client-brand">
            <span className="client-brand-mark">R</span>
            RGNR Capital
          </NavLink>

          <nav className="client-nav-links">
            {NAV.map((item) => {
              const Icon = item.icon;
              return (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className={({ isActive }) =>
                    `client-nav-link${isActive ? ' active' : ''}`
                  }
                >
                  <Icon size={16} />
                  {item.label}
                </NavLink>
              );
            })}
          </nav>

          <div className="client-nav-actions">
            <button
              className="client-icon-btn"
              onClick={toggleTheme}
              title={theme === 'dark' ? 'Light mode' : 'Dark mode'}
            >
              {theme === 'dark' ? <Sun size={16} /> : <Moon size={16} />}
            </button>
            <UserMenu />
            <button
              className="client-icon-btn client-nav-mobile-toggle"
              onClick={() => setMobileOpen((v) => !v)}
              aria-label="Toggle menu"
            >
              {mobileOpen ? <X size={18} /> : <Menu size={18} />}
            </button>
          </div>
        </div>
      </header>

      <nav className={`client-mobile-nav${mobileOpen ? ' open' : ''}`}>
        {NAV.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `client-nav-link${isActive ? ' active' : ''}`
              }
              onClick={() => setMobileOpen(false)}
            >
              <Icon size={16} />
              {item.label}
            </NavLink>
          );
        })}
      </nav>

      <main className="client-main">
        <Outlet />
      </main>
    </div>
  );
}

export default ClientLayout;
